module.exports = __webpack_public_path__ + "img/Escapify-white.5fa62fb5.png";